// eslint-disable-next-line no-unused-vars
const canRequire = typeof __webpack_require__ === 'function';

module.exports =
{
    theme: 'dark', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Klimawandel in den Alpen: Das Eis der Zugspitze schmilzt',
        // Beschreibung
        description: 'Bis zum Ende des Jahrhunderts werden sich die Alpen stark verändern. Erkunden Sie an Deutschlands höchstem Berg interaktiv in 3D, was der Klimawandel für Gletscher und Wintersport bedeutet.',
        // Bild
        image: 'https://3d.zdf.de/zugspitze-alpen-klimawandel/img/linkpreview.jpg',
        // URL
        url: 'https://3d.zdf.de/zugspitze-alpen-klimawandel/',
    },
    tracking: {
        storyName: 'Zugspitze in 3D',
        storyID: 'Zugspitze',
        // Tracking deaktivieren
        //disabled: true,
    },
    babylon: {
        lightIntensity : 1,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position:  [.92,.95,98],//[.5 * Math.PI, .5 * Math.PI, 10], // alpha, beta, radius   //VÖ.95,1,130
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [-2, 8, -5.4], // Wohin die Kamera blickt   //VÖ-0.5, 8.5, -6
            animationSpeed: 250, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            alphaLimits: [null, null],
            betaLimits: [0.1, Math.PI / 2],
            radiusLimits: [3.5, 130], // minCamRadius, maxCamRadius
            clipping: [.7, 10000.0],
            fov: 0.5,  //0.8

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 25.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true,
        // Dauerhafte Hintergrund Musik
        //background: canRequire && require('./assets/audio/News_Loop3.mp3'),
    },
    objects:
    [
        // {
        //     // Name des Objekts zur Ansteuerung
        //     name: "zdfLogo",
        //     // GLB Dateiname im Ordner app/public/3d-models
        //     filename: "ZDF_Logo.glb",
        //     options: {
        //         //// BaseObject
        //         // true: Objekt anzeigen
        //         visible: true,
        //         // Skalierung: Objekt Größe ändern in allen Dimensionen
        //         scaling: [1, 1, -1],
        //         // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
        //         //scale: 0.01,
        //         // Position
        //         position: [0, 0, 0],
        //         // Rotation
        //         rotation: [0.5 * Math.PI, 0, 0],
        //         // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
        //         //rotationQuaternion: [0.707, 0, 0, 0.707],
        //         // Transparenz (0 bis 1)
        //         //visibility: 0.25,
        //         // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
        //         //diffuse: [255, 0, 0],
        //         // Zur Kamera ausrichten
        //         // 1: X-Achse, 2: Y-Achse, 4: Z-Achse, 7: Alle Achsen
        //         // 3: X & Y-Achse, 5: Z & X-Achse, 6: Z & Y-Achse
        //         // https://doc.babylonjs.com/typedoc/classes/babylon.abstractmesh#billboardmode
        //         billboardMode: 0,
        //         // Overlay Color zum hervorheben von Objekten
        //         //overlayColor: [250/255, 125/255, 25/255],
        //         // Rendering Group ID legt Objekte eine ebene nach vorne (Auch beim Hotspot)
        //         //renderingGroupId: 1

        //         //// MeshObject
        //         // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
        //         fade: false,
        //         // Unter-Mesh-Objekte in der Datei
        //         // Name des Meshs wie im 3D Model
        //         ZDF_Logo: {
        //             visible: true,
        //             fade: false,
        //             // Ist das Objekt anklickbar?
        //             // Bei true wird ein Hotspot durch das Objekt nicht anklickbar, wenn verdeckt.
        //             // Darum sollte bei transparenten Objekten ggf. pickable: false gesetzt werden.
        //             pickable: true,

        //             ZDF_Logo_2: {
        //                 visible: true,
        //                 fade: false,
        //             }
        //         },

        //         //// BabylonObject
        //         // animation=true: startet die Animation im Objekt
        //         animation: false,

        //         // Nur initial, nicht per babylonState
        //         // OnClick Trigger
        //         // trigger: function () { }
        //     },
        //     // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
        //     callback: function (zdfLogo) // eslint-disable-line no-unused-vars
        //     {

        //     }
        // },
        // Dies koennte ein zweites Objekt sein, das ihr ladet.
        {
            name: "zugspitze",
            filename: "zugspitze.glb",
            options: {
                visible: true,
                position: [0, 0, 0],
                scaling: [.05, .05, -.05],
                rotation: [0, 0, 0],
                children:{
                    sphere360:{
                        visibility: false,
                        pickable: false,
                    },
                    Bake_Platte_Totale:{
                        pickable: false,
                    },

                    Detail_Gipfel:{
                        pickable: false,
                    },

                    Bake_Detail_Hoellentalgletscher:{
                        pickable: false,
                    },

                    Bake_Overlay_Plattach:{
                        visibility: false,
                        pickable: false,
                    },


                    Bake_Overlay_Skigebiet:{
                        visibility: false,
                        pickable: false,
                    },

                    Zugspitzbahn_Dummy:{
                        visibility: false,
                    },


                    Gitter:{
                        visible: false
                    },


                    Gitter_1500m:{
                        visible: false
                    },

                    Label_BG_Schneegrenze:{
                        visible: false,
                        //billboardMode: 7,
                        children:{
                            Text_Grenzzahl:{
                                visible: false
                            },
                            Text_Schneegrenze:{
                                visible: false,
                            }
                        }
                    },


                    Label_BG_Zugspitzbahn:{
                        visibility: false,
                        children:{
                            Text_Zugspitzbahn:{
                                visibility:false,
                            },
                        },
                    },

                    Label_BG_NFerner:{
                        visibility: false,
                        //scale:[1,1,1],
                        children:{
                            Text_NFerner:{
                                visibility: false,
                            },
                        }
                    },

                    Label_BG_HFerner:{
                        visibility: false,
                        children:{
                            Text_HFerner:{
                                visibility: false,
                            },
                        }
                    },

                    Label_BG_SFerner:{
                        visibility: false,
                        children:{
                            Text_SFerner:{
                                visibility: false,
                            },
                        }
                    },

                    Label_BG_1892:{
                        visible: false,
                        //billboardMode:7
                    },
                },
            },

            callback: function (zugspitze) // eslint-disable-line no-unused-vars
                {
                    let MAT_BG_Sphere = this.scene.getNodeByName('sphere360').material;
                    MAT_BG_Sphere.disableLighting = true;

                    let MAT_BG_Label_weiss = this.scene.getNodeByName('Label_BG_NFerner').material;
                    MAT_BG_Label_weiss.disableLighting = true;
                    MAT_BG_Label_weiss.emission = 1;

                    let MAT_BG_Label_tuerkis = this.scene.getNodeByName('Gitter').material;
                    MAT_BG_Label_tuerkis.disableLighting = true;


                    let MAT_Sonne = this.scene.getNodeByName('Sonne').material;
                    MAT_Sonne.disableLighting = true;
                    MAT_Sonne.alphaMode = 1;
                    MAT_Sonne.transparencyMode = 2
                }
        },
    ]
};
